// Not `next/server`: that barrel eagerly loads NextRequest and request-scoped APIs, which would ship to
// client components that call this.
import { userAgentFromString } from 'next/dist/server/web/spec-extension/user-agent';
import type { PageContext } from './pageContext';

/**
 * True for phones only. Tablets, and clients the parser cannot place, count as
 * desktop: the desktop layout is what every visitor receives today, so a misread
 * costs a visitor the usual page instead of an untested one.
 *
 * A user-agent cannot report viewport width, so this never lines up exactly with
 * a CSS breakpoint. A caller that renders one layout per device must therefore
 * drive the markup AND everything derived from it (server-computed ordering,
 * analytics gates) from this single value. Mixing it with a media query lets the
 * two disagree for the same visitor.
 */
export const isMobileDevice = ({ userAgent: ua }: Pick<PageContext, 'userAgent'>): boolean =>
  userAgentFromString(ua || undefined).device.type === 'mobile';
